import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiArrowLeft, FiExternalLink } from "react-icons/fi";
import SEO from "../components/SEO";

const BROCHURE_URL = process.env.PUBLIC_URL + "/brosur/demar-tanitim-2026.html";

export default function Brochure() {
  const { t } = useTranslation();
  return (
    <div>
      <SEO title={t("brochure.meta_title")} description={t("brochure.meta_desc")} />
      <div className="brochure-bar">
        <Link to="/" className="link-arrow"><FiArrowLeft /> {t("brochure.back")}</Link>
        <span className="brochure-title">{t("brochure.title")}</span>
        <a href={BROCHURE_URL} target="_blank" rel="noopener noreferrer" className="btn sm">
          {t("brochure.openNewTab")} <FiExternalLink />
        </a>
      </div>
      <iframe src={BROCHURE_URL} title={t("brochure.title")} className="brochure-frame" loading="lazy" />
    </div>
  );
}
